import {
    HttpResponse,
    DepartmentModel,
    QueryModel,
    RequestParams,
    DepartmentModelIEnumerableApiResultSuccess,
    DepartmentModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class DepartmentsDataService implements CrudService<DepartmentModel, DepartmentModel> {
    getAll(query: CrudDataQuery<DepartmentModel>): Promise<CrudEnumerableResponse<DepartmentModel>> {
        return ApiService.api.getDepartmentBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<DepartmentModel>): Promise<CrudEnumerableResponse<DepartmentModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<DepartmentModel>> {
        return ApiService.api.getDepartmentById(id, params);
    }

    create(item: DepartmentModel, params?: RequestParams): Promise<CrudResponse<DepartmentModel>> {
        return ApiService.api.insertDepartment(item, params);
    }

    update(item: DepartmentModel, params?: RequestParams): Promise<DepartmentModel> {
        return ApiService.api.updateDepartment(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<DepartmentModel> {
        return ApiService.api.patchDepartment(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<DepartmentModel>): Promise<CrudEnumerableResponse<DepartmentModel>> {
        return ApiService.api.deleteDepartments(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationDepartment(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<DepartmentModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: DepartmentModel, params?: RequestParams): Promise<CrudResponse<DepartmentModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getDepartmentGroupped(query, params);
    }

}
